import React, { useState } from 'react';
import { Box, Button, H3, Input, Modal, ModalContent, Select, T } from '@veracity/vui';
import { useCreateChecklist } from '../api/templates';
import { useNavigate } from 'react-router-dom';

const TemplateSelectModal = ({ isOpen, onClose, templates }) => {
    const [checklistName, setChecklistName] = useState('');
    const [selectedTemplateId, setSelectedTemplateId] = useState('');
    const [checklistTag, setChecklistTag] = useState('');
    const createChecklistMutation = useCreateChecklist();

    const navigate = useNavigate();

    const handleSelectTemplate = (e) => {
        const templateId = e.target.value;
        setSelectedTemplateId(templateId);

        if (templateId) {
            const template = templates?.find(t => t.id === templateId);
            if (template) {
                setChecklistTag(template.tag);
            }
        }
    };

    const handleSubmit = async () => {
        if (!checklistName.trim() || !selectedTemplateId) {
            alert('Please enter a checklist name and select a template');
            return;
        }
        
        try {
            await createChecklistMutation.mutateAsync({
                templateId: selectedTemplateId,
                data: {
                    name: checklistName,
                    tag: checklistTag
                }
            });
            handleClose();
            navigate('/checklists');
        } catch (error) {
            console.error("Error creating checklist", error);
            alert('Failed to create checklist. Please try again.');
        }
    }

    const handleClose = () => {
        setChecklistName('');
        setSelectedTemplateId('');
        setChecklistTag('');
        onClose();
    }

    const templateOptions = templates?.map(template => ({
        text: template.name,
        value: template.id
    }));
   

    return (
        <Modal isOpen={isOpen} onClose={handleClose} disableBackdropClose>
            <ModalContent>
                    <Box 
                        flexDirection="column" 
                        gap={2} 
                        bg="white"
                        boxShadow="modal"
                        left="50%"
                        top="50%"
                        transform="translate(-50%, -50%)"
                        position="absolute"
                        p={4}
                        borderRadius={2}
                        outline="none"
                        // w="800px"
                        minW="50%"
                    >
                        <H3 fontWeight="demi" alignSelf="center" mb={2}>Create Checklist</H3>
                        <Box flexDirection="column" gap={1} alignItems="flex-start">
                            <T fontWeight="demi">Checklist Name <span style={{color: 'red'}}>*</span></T>
                            <Input 
                                value={checklistName} 
                                onChange={(e) => setChecklistName(e.target.value)} 
                                placeholder="Enter Checklist Name"
                                w="100%"
                            />
                            
                        </Box>
                        <Box flexDirection="column">
                            <T fontWeight="demi">Template</T>
                            <Select
                                onChange={handleSelectTemplate}
                                options={templateOptions}
                                placeholder="Select a template"
                                value={selectedTemplateId} 
                            />
                        </Box>
                        <Box>
                            <Button variant='secondaryDark' onClick={handleClose}>Cancel</Button>
                            <Button variant='primaryDark' onClick={handleSubmit} isLoading={createChecklistMutation.isLoading} ml={2}>Create</Button>
                        </Box>
                    </Box>
            </ModalContent>
        </Modal>
    );
}
    
    

export default TemplateSelectModal;